<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="MBA"
                   :links="[{title:'Home', url:'/'},{title:'Infrastructure'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="6"></sidebar>
        </section>
        <section class="content">
            <div class="heading-black1">Infrastructure</div>
            <v-carousel :items-to-show="1" :autoplay="3000" :wrapAround="true" :transition="3000">
              <v-slide v-for="(item, index) in infraItems" :key="index">
                <infrastructure-card :infra-item="item" class="w-100" :dir="dirName"></infrastructure-card>
              </v-slide>
            </v-carousel>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/mba/Sidebar";
import {Carousel as VCarousel, Slide as VSlide} from 'vue3-carousel';
import InfrastructureCard from "@/components/InfrastructureCard";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "Infrastructure",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    KeyRecruiters,
    VCarousel,
    VSlide,
    InfrastructureCard

  },
  data() {
    return {
      dirName: 'mba',
      infraItems: [
        {
          name: 'MBA Lab Photo',
          image: 'com_lab',
        },
        {
          name: 'Seminar Hall 1',
          image: 'seminar1',
        },
        {
          name: 'Seminar Hall 2',
          image: 'seminar2',
        },
        {
          name: 'HOD',
          image: 'hod',
        },
        {
          name: 'MBA Lab Photo',
          image: 'com_lab',
        },
      ],

    }
  }
}
</script>
<style lang="scss" scoped/>
